export default __webpack_public_path__ + "static/media/video-icon.22184307.svg";